export default __webpack_public_path__ + "079d9afbbfa386c00e089d4c017e374c.png";